import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomViewButton from "../../../CustomComponent/custom_view_button";
import performRequest from "../../../api/request";

const NurseryBatchTable = ({
  BatchData = [],
  currentPage,
  itemsPerPage,
  showArchived,
  onActionComplete,
}) => {
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const [archieveStatus, setArchieveStatus] = useState();

  const goToView = (id) => {
    navigate(`/farm-nursery-management/view/${id}`);
  };

  const getScheduleProgress = (schedule) => {
    if (schedule && schedule.length > 0) {
      let count = 0;
      for (let i = 0; i < schedule.length; i++) {
        if (schedule[i].scheduleDone) {
          count += 1;
        }
      }
      const progress = (count / schedule.length) * 100;
      return {
        progressStatus: `${count}/${schedule.length}`,
        progressPercentage: progress,
      };
    } else {
      return {
        progressStatus: "Not Started",
        progressPercentage: 0,
      };
    }
  };

  const returnClassnameBg = (progressPercentage, batch) => {
    const currentDate = new Date();
    const batchStartDate = new Date(batch.batchStartDate);
    const batchEndDate = new Date(batch.batchEndDate);
    if (currentDate >= batchStartDate && currentDate <= batchEndDate) {
      return { backgroundColor: "rgba(255, 255, 102, 0.2)" };
    }
    return progressPercentage < 83
      ? { backgroundColor: "rgba(255, 99, 71, 0.2)" }
      : { backgroundColor: "rgba(144, 238, 144, 0.2)" };
  };

  const archiveBatch = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/nurseryManagement/updateArchiveStatus/${id}`,
        {
          archieveData: true,
        }
      );
      if (res.status === 200) {
        onActionComplete(); // 🔥 refresh list
      }
    } catch (err) {
      // Toast("error", "Server error");
      console.log(err);
    }
  };

  const restoreBatch = async (id) => {
    try {
      const res = await performRequest(
        "PATCH",
        `/nurseryManagement/updateArchiveStatus/${id}`,
        { archieveData: false }
      );

      if (res.status === 200) {
        onActionComplete(); // 🔥 refresh list
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            <th>Sr.</th>
            {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
              <th className="d-none d-md-table-cell">Farm Name</th>
            )}
            <th className="d-none d-md-table-cell">Batch Name</th>
            <th className="d-none d-md-table-cell">Start Date</th>
            <th className="d-none d-md-table-cell">End Date</th>
            <th className="d-md-none d-sm-table-cell">Start Date/Batch Name</th>
            <th>Progress</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {BatchData?.map((batch, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;
            const { progressStatus, progressPercentage } = getScheduleProgress(
              batch?.schedule
            );

            return (
              <tr
                key={batch?.id}
                style={returnClassnameBg(progressPercentage, batch)}
              >
                <td>{Index}</td>
                {store.Role !== process.env.REACT_APP_ROLE_CLIENT && (
                  <td className="d-none d-md-table-cell">
                    {batch?.farmName || "N/A"}
                  </td>
                )}
                <td className="d-none d-md-table-cell">
                  {batch?.batchName || "N/A"}
                </td>
                <td className="d-none d-md-table-cell">
                  {batch?.batchStartDate || "N/A"}
                </td>
                <td className="d-md-none d-sm-table-cell">
                  {batch?.batchStartDate || "N/A"}
                  <br />
                  <span>{batch?.batchName || "N/A"}</span>
                </td>
                <td className="d-none d-md-table-cell">
                  {batch?.batchEndDate || "N/A"}
                </td>
                <td>{progressStatus}</td>
                <td>
                  <div className="d-flex gap-2">
                    <CustomViewButton onClick={() => goToView(batch.id)} />

                    {!showArchived ? (
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => archiveBatch(batch.id)}
                      >
                        Archive
                      </button>
                    ) : (
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => restoreBatch(batch.id)}
                      >
                        Restore
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default NurseryBatchTable;
